<template>
  <el-form
    ref="form"
    :label-position="labelPosition"
    :model="form"
    :rules="rules"
    label-width="80px"
  >
    <el-form-item
      label="用户名"
      prop="userName"
    >
      <el-input
        placeholder="登录帐号"
        v-model="form.userName"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="password"
      label="密码"
      :class="{ 'is-required': !form.userId }"
    >
      <el-input
        type="password"
        show-password
        placeholder="请输入"
        v-model="form.password"
      ></el-input>
    </el-form-item>
    <el-form-item
      prop="comfirmPassword"
      label="确认密码"
      :class="{ 'is-required': !form.userId }"
    >
      <el-input
        v-model="form.comfirmPassword"
        placeholder="请确认密码"
        class=""
        type="password"
        show-password
      ></el-input>
    </el-form-item>
    <el-form-item
      label="邮箱"
      prop="email"
    >
      <el-input
        v-model="form.email"
        placeholder="请输入邮箱"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="手机号"
      prop="mobile"
    >
      <el-input
        v-model="form.mobile"
        placeholder="请输入手机"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="roleList.length"
      label="角色"
      size="mini"
      prop="roleId"
    >
      <el-checkbox-group
        v-model="form.roleId"
      >
        <el-checkbox
          v-for="role in roleList"
          :key="role.roleId"
          :label="role.roleId"
        >{{ role.roleName }}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item
      label="状态"
      size="mini"
      prop="status"
    >
      <el-radio-group v-model="form.status">
        <el-radio :label="0">禁用</el-radio>
        <el-radio :label="1">正常</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      size="mini"
      label="授权"
    >
      <el-tree
        :data="permissionList"
        :props="menuListTreeProps"
        node-key="id"
        ref="menuListTree"
        :default-expand-all="true"
        show-checkbox
      >
      </el-tree>
    </el-form-item>
  </el-form>
</template>

<script>
import { treeDataTranslate } from '@/utils/common'

import {validatEmail,isMobile} from "@/utils/validate";
import {queryPermissionList, queryRoleList,queryPermissionKeys } from "@/api/sys/userList";
let origin = {
  userId: '',
  userName: '',
  comfirmPassword: '',
  email: '',
  mobile: '',
  roleId: [],
  status: '',
}
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "roleForm",
  props: {
    formData:{
      type: Object,
      default(){
        return {
          userId: ''
        };
      }
    }
  },
  data() {
    let _this = this;
    var validatePassword = (rule, value, callback) => {
      if(_this.form.userId){
        callback()
      }else {
        if (!/\S/.test(value)) {
          callback(new Error('密码不能为空'))
        } else {
          callback()
        }
      }
    }
    var validateComfirmPassword = (rule, value, callback) => {
      if(_this.form.userId){
        callback();
      }else {
        if (!/\S/.test(value)) {
          callback(new Error('确认密码不能为空'))
        } else if (_this.form.password !== value) {
          callback(new Error('确认密码与密码输入不一致'))
        } else {
          callback()
        }
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (!validatEmail(value)) {
        callback(new Error('邮箱格式错误'))
      } else {
        callback()
      }
    };
    var validateMobile = (rule, value, callback) => {
      if (!isMobile(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    };
    return {
      roleList: [],
      permissionList: [],
      form: JSON.parse(JSON.stringify(origin)),
      rules: {
        userName: [
          { required:true, message: '请选择', trigger: 'blur' },
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' },
        ],
        comfirmPassword: [
          { validator: validateComfirmPassword, trigger: 'blur' },
        ],
        email: [
          { required:true, message: '邮箱不能为空', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        mobile: [
          { required:true, message: '手机不能为空', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        roleId: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
        status: [
          { required:true, message: '请选择', trigger: 'change' },
        ],
      },
      menuListTreeProps: {
        label: 'nodeName',
        children: 'children'
      }
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.userId){
          this.assigen(newValue);
          this.getKeys();
        }
      },
      deep: true,
    }
  },
  mixins: [formLabalPosition],
  created(){
    this.getRoleList();
    this.getPermissionMenuSelectList();
  },
  methods: {
    getPermissionMenuSelectList(){
      queryPermissionList({
        'page': 1,
        'limit': 10000,
        'sidx': 'id',
        'order':'desc'
      }).then((res) => {
        this.permissionList = treeDataTranslate(res.page.list, 'id')
      })
    },
    getKeys(){
      queryPermissionKeys({
        'userId':this.form.userId,
      }).then((res) => {
        this.$refs.menuListTree.setCheckedKeys([])
        if( res.userTreeIds.length>0){

          this.$refs.menuListTree.setCheckedKeys(res.userTreeIds)
        }
      })
    },
    getRoleList(){
      queryRoleList().then((res) => {
        this.roleList = res.list || [];
      })
    },
    reset(){
      this.form = JSON.parse(JSON.stringify(origin));
    },
    assigen(user){
      this.form.userId = user.userId;
      this.form.userName = user.username;
      this.form.email = user.email;
      this.form.mobile = user.mobile;
      this.form.status = user.status;
      this.form.roleId =user.roleIdList;
    },
    // 菜单树设置当前选中节点
    // 上级菜单有时候编辑的时候没有对得上,有点问题, todo

    selfValidate() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.$emit('submit',this.form);
        }
      })
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.reset();
    },
  },
}
</script>

<style scoped>

</style>
